import {
  type ColumnDefinition,
  FilterSearchAndSelect,
  Table,
  type TableProps,
  getFilterYearOptions,
} from "@pharmupp/p3-front-commons"
import type { Config } from "@pharmupp/p3-front-commons/src/components/dataDisplay/table/useResourceListApi/types"
import type { ReactNode } from "react"
import { marketingOperationCurrentYear } from "../marketingOperationCurrentYear"
import { marketingOpTypesReferential } from "../marketingOperationReferential"

interface MarketingOperationsListProps<
  QueryResource = unknown,
  Resource = QueryResource,
  ExtraRowApi = {},
> extends Pick<
    TableProps<QueryResource, Resource, ExtraRowApi>,
    "onRowClick" | "rowClickCondition" | "extraRowApi"
  > {
  queryConfig: Config<QueryResource, Resource>
  extraFilterElement?: ReactNode
  columns: ColumnDefinition<Resource, ExtraRowApi>[]
}

const yearOption = getFilterYearOptions({
  nbPreviousYearsToDisplay: 3,
  baseYear: marketingOperationCurrentYear,
})

export const MarketingOperationsList = <
  QueryResource = unknown,
  Resource = QueryResource,
  ExtraRowApi = {},
>({
  queryConfig,
  extraFilterElement,
  onRowClick,
  rowClickCondition,
  columns,
  extraRowApi,
}: MarketingOperationsListProps<QueryResource, Resource, ExtraRowApi>) => {
  return (
    <Table<QueryResource, Resource, ExtraRowApi>
      queryConfig={queryConfig}
      extraRowApi={extraRowApi}
      FilterSectionElement={
        <>
          <FilterSearchAndSelect label="Année" name="year" options={yearOption} />
          <FilterSearchAndSelect
            label="Type"
            name="type"
            options={marketingOpTypesReferential}
          />
          {extraFilterElement}
        </>
      }
      emptyMessage="Aucune opération"
      columns={columns}
      searchDefaultOpen
      searchPlaceholder="Je recherche une opération"
      onRowClick={onRowClick}
      rowClickCondition={rowClickCondition}
    />
  )
}
